import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RegisterForm from "./Components/Register Form/RegisterForm";
import ThankYouForm from './Components/ThankYouForm/ThankYouForm';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/register/" element={<RegisterForm />} />
        <Route path="/register/thank-you" element={<ThankYouForm />} />
      </Routes>
    </Router>
  );
}

export default App;
